/**
 * Create a folder in storage by uploading a zero-byte ".keep" file.
 * Uses the appropriate storage service based on craftspace configuration.
 *
 * Note: For S3 craftspaces, this function will fall back to 360crafter cloud storage
 * if S3 credentials are not available (e.g., during project creation).
 * This ensures project creation doesn't fail due to missing S3 credentials.
 *
 * @deprecated This function is no longer used as we don't create empty folders.
 * Folders will be created automatically when files are uploaded to them.
 */
async function _createFolder(
  path: string,
  _craftspaceId: string,
  _bucket: string = "staging",
  _password?: string,
) {
  // No longer creating empty folders with .keep files
  // Folders will be created automatically when files are uploaded
  console.log(
    `Skipping empty folder creation for ${path} - folders will be created when files are uploaded`,
  );
  return;
}

/**
 * Create all base folders for a craftspace (shared, temp, etc)
 *
 * @deprecated This function no longer creates empty folders.
 * Folders will be created automatically when files are uploaded to them.
 */
export async function createCraftspaceFolders(craftspaceId: string, _password?: string) {
  // No longer creating empty folders with .keep files
  // Folders will be created automatically when files are uploaded
  console.log(
    `Skipping craftspace folder creation for ${craftspaceId} - folders will be created when files are uploaded`,
  );
  return;
}

/**
 * Create all base folders for a project inside a craftspace
 *
 * @deprecated This function no longer creates empty folders.
 * Folders will be created automatically when files are uploaded to them.
 */
export async function createProjectFolders(craftspaceId: string, projectId: string) {
  // No longer creating empty folders with .keep files
  // Folders will be created automatically when files are uploaded
  console.log(
    `Skipping project folder creation for ${projectId} in craftspace ${craftspaceId} - folders will be created when files are uploaded`,
  );
  return;
}

/**
 * Create a specific project folder when needed (e.g., before uploading files)
 *
 * @deprecated This function no longer creates empty folders.
 * Folders will be created automatically when files are uploaded to them.
 */
export async function ensureProjectFolder(
  _craftspaceId: string,
  projectId: string,
  folderType: "panoramas" | "hotspots" | "skins" | "exports",
) {
  // No longer creating empty folders with .keep files
  // Folders will be created automatically when files are uploaded
  console.log(
    `Skipping project folder creation for ${folderType} in project ${projectId} - folders will be created when files are uploaded`,
  );
  return;
}
